import React, { useState } from 'react';
import {
  correctInternalLink,
  isItUndefined,
  isLinkAbsolute,
  modifyLinks,
} from '../../util/DataUtil';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getEditorColor } from '../../util/ColorUtil';
import { cleanHTML } from '../utils/htmlUtils';
import MapWithPulse from '../product-family-template/MapWithPulse';

const MapPulseEffect = ({ data, lang }) => {
  const router = useRouter();
  const emphasizedTextColor = getEditorColor(
    isItUndefined(data?.field_title_color)
  );
  const [isHoverActive, setIsHoverActive] = useState(false);

  return (
    <div
      className={'a-map-pulse-effect map-pulse-effect'}
      onMouseOver={() => setIsHoverActive(!isHoverActive)}
      onMouseOut={() => setIsHoverActive(!isHoverActive)}
      onClick={() => {
        if (isLinkAbsolute(data?.field_link[0]?.uri)) {
          window.open(data?.field_link[0]?.uri, '_blank');
        } else {
          router.push(correctInternalLink(data?.field_link[0]?.uri));
        }
      }}
    >
      <a
        className="inner-container"
        href={
          data?.field_link[0]?.uri
            ? correctInternalLink(data?.field_link[0]?.uri)
            : ''
        }
      >
        <MapWithPulse />
        <div className={'helper-left-margin-container-new'}>
          <div
            className={`title ${lang === 'de' ? 'title-de' : ''} ${lang === 'nl' ? 'title-nl' : ''} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
            dangerouslySetInnerHTML={{
              __html: cleanHTML(modifyLinks(data?.field_title_color[0]?.value)),
            }}
          />
          {data?.field_link[0]?.title ? (
            <Link
              href={
                data?.field_link[0]?.uri
                  ? correctInternalLink(data?.field_link[0]?.uri)
                  : ''
              }
              passHref
              legacyBehavior
            >
              <a
                target={
                  isLinkAbsolute(data?.field_link[0]?.uri) ? '_blank' : '_self'
                }
                className={`a-full-width-image-banner-link cta-link ${lang === 'fr' ? 'cta-link-fr' : lang === 'es' ? 'cta-link-es' : ''} ${emphasizedTextColor} ${isHoverActive ? ' hovered' : ''}`}
              >
                {data?.field_link[0]?.title}
              </a>
            </Link>
          ) : null}
        </div>
      </a>
    </div>
  );
};

export default MapPulseEffect;
